import React, { useEffect, useState } from 'react'
import { Box, styled, TextField, Typography, Grid, InputAdornment, Button } from '@mui/material';
import createInstance from '../../api/axiosinstance';
import { useSelector } from 'react-redux';

const CssTextField = styled(TextField)({
  '& label': {
    color: '#FEFEFE',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#B9B9B9',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#B9B9B9',
      borderRadius: 10,
    },
    '&:hover fieldset': {
      borderColor: '#B9B9B9',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#B9B9B9',
    },
    '& .MuiInputBase-input': {
      color: '#FEFEFE',
    },
  },
});

const Candidate = () => {
    const { isAuthenticated, user } = useSelector((state) => state.auth);
    console.log("candidate login", user, isAuthenticated);
    
    // Initialize state with empty values
    const [dateAndTime, setDateAndTime] = useState(""); 
    const [round, setRound] = useState(""); 
    const [jobTitle, setJobTitle] = useState(""); 
    const [link, setLink] = useState(""); 
    const [help, setHelp] = useState("");
    const [canName, setCanName] = useState("");
    const [showLink, setShowLink] = useState(false);
    const aiDishaApi = createInstance("DISHA");
    
    // Get values from session storage
    const candidateId = user.candidateId;
    const organizationId = user.organizationId;
    const candEmail = window.sessionStorage.getItem("candEmail");
    const [candIntDetails, setCandIntDetails] = useState([]);
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
    
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    
    const handleViewModalOpen = () => {
      setIsViewModalOpen(true);
    };
    
    const handleViewModalClose = () => {
      setIsViewModalOpen(false);
    };
    
    const toggleLinkDisplay = () => {
      setShowLink(!showLink);
    };
    
    useEffect(() => {
      console.log("Candidate ID from session:", candidateId);
      console.log("Organization ID from session:", organizationId);
      
      if (!candidateId || !organizationId) {
        console.error("Missing candidate_id or organizationId in session storage");
        return;
      }
      
      getInterviewDetails();
    }, [candidateId, organizationId]);

    const getInterviewDetails = async () => {
      try {
        const response = await aiDishaApi.get(`/candidate_upcoming_interviews?candidate_id=${candidateId}&organization_id=${organizationId}`);
        console.log("interview details", response.data);
        
        if (response.data && response.data.upcoming_interviews) {
          setCandIntDetails(response.data.upcoming_interviews);
          
          // If we have interview details, set the first one
          if (response.data.upcoming_interviews.length > 0) {
            const interview = response.data.upcoming_interviews[0];
            setDateAndTime(interview.interview_date_and_time);
            setCanName(interview.candidate_name)
            setRound(interview.round);
            setJobTitle(interview.job_title);
            setLink(interview.meeting_link);
            setHelp(interview.interview_panel);
          }
        }
      } catch (error) {
        console.error("Error fetching interview details:", error);
      }
    };

    // Format date and time for display
    const formatDateTime = (dateTimeString) => {
      if (!dateTimeString) return "";
      
      try {
        const date = new Date(dateTimeString);
        return date.toLocaleString();
      } catch (e) {
        return dateTimeString;
      }
    };

    return (
      <Box
        sx={{
          backgroundColor: "#061E3F",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            padding: 4,
            borderRadius: 4,
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            width: "100%",
            maxWidth: 600,
          }}
        >
          <Typography variant="h4" gutterBottom textAlign="center" color="black">
            Your Interview Details
          </Typography>

          <Grid container spacing={2}>
          <Grid item xs={12}>
              <Typography variant="h8" color={'black'}>Candidate Name</Typography>
              <TextField
                fullWidth
                value={canName}
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h8" color={'black'}>Interview Slot</Typography>
              <TextField
                fullWidth
                value={formatDateTime(dateAndTime)}
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h8" color={'black'}>Round</Typography>
              <TextField
                fullWidth
                value={round}
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h8" color={'black'}>Job Details</Typography>
              <TextField
                fullWidth
                value={jobTitle}
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h8" color={'black'}>Meeting Link</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={toggleLinkDisplay}
                  sx={{ 
                    backgroundColor: '#1976d2',
                    '&:hover': {
                      backgroundColor: '#1565c0'
                    }
                  }}
                >
                  {showLink ? 'Hide Link' : 'Show Link'}
                </Button>
                {showLink && (
                  <Button
                    component="a"
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    color="primary"
                    sx={{ 
                      ml: 1, 
                      flexGrow: 1,
                      textTransform: 'none',
                      justifyContent: 'flex-start',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {link}
                  </Button>
                )}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h8" color={'black'}>Interviewer Name</Typography>
              <TextField
                fullWidth
                value={help}
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
}

export default Candidate;